var _defs, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSuccessStories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.91 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4edfe;\n      }\n\n      .cls-2 {\n        fill: #823df5;\n      }\n\n      .cls-3 {\n        fill: #c6aafc;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.95,
    cy: 26,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.95,49.5c-12.96,0-23.5-10.54-23.5-23.5S13.99,2.5,26.95,2.5s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM26.95,4C14.82,4,4.95,13.87,4.95,26s9.87,22,22,22,22-9.87,22-22S39.08,4,26.95,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.31,22.09l-6.2-.8-2.68-5.65c-.16-.34-.44-.62-.78-.78-.82-.39-1.81-.04-2.2.78l-2.67,5.65-6.2.8c-.37.05-.72.23-.97.5-.63.66-.6,1.7.05,2.33l4.54,4.29-1.16,6.14c-.02.1-.03.2-.03.29,0,.91.74,1.65,1.65,1.65v-.25s0,0,0,0h0s0,.25,0,.25c.28,0,.55-.07.79-.2l5.48-2.99,5.48,2.99c.33.18.71.24,1.08.17.43-.08.81-.32,1.06-.69.25-.36.34-.8.27-1.24l-1.16-6.14,4.54-4.29c.27-.26.45-.6.5-.97.12-.9-.51-1.73-1.42-1.86ZM34.38,24.61l-3.8,3.59.97,5.14-4.59-2.51-4.59,2.51.97-5.14-3.8-3.59,5.19-.67,2.24-4.73,2.24,4.73,5.19.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSuccessStories);
export default __webpack_public_path__ + "static/media/View Success Stories.347463fbd7e227b1824e18c4ad051942.svg";
export { ForwardRef as ReactComponent };